import { render } from "./AppHeader.vue?vue&type=template&id=46612820"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=46612820&lang=css"

import exportComponent from "/media/innovation/79c7daf6-b2a2-46d5-881e-4039c99a3fb61/home/innovation/Documents/project/pharmacy/connect to obr/terachpharmacy/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__